var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVertical2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C10.1 4 11 4.9 11 6C11 7.1 10.1 8 9 8C7.9 8 7 7.1 7 6C7 4.9 7.9 4 9 4Z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4C16.1 4 17 4.9 17 6C17 7.1 16.1 8 15 8C13.9 8 13 7.1 13 6C13 4.9 13.9 4 15 4Z",
    fill: "#A1A5B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C10.1 10 11 10.9 11 12C11 13.1 10.1 14 9 14C7.9 14 7 13.1 7 12C7 10.9 7.9 10 9 10Z",
    fill: "#A1A5B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C16.1 10 17 10.9 17 12C17 13.1 16.1 14 15 14C13.9 14 13 13.1 13 12C13 10.9 13.9 10 15 10Z",
    fill: "#A1A5B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16C10.1 16 11 16.9 11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16Z",
    fill: "#A1A5B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16C16.1 16 17 16.9 17 18C17 19.1 16.1 20 15 20C13.9 20 13 19.1 13 18C13 16.9 13.9 16 15 16Z",
    fill: "#A1A5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical2);
export default __webpack_public_path__ + "static/media/dots-vertical-2.33f5d49c03f95d1ea8096ed93677c1c5.svg";
export { ForwardRef as ReactComponent };